const OrderStepType = {
  ALERTED: 'alerted',
  OFF: 'off',
  ON: 'on',
};

export default OrderStepType;
